import { render } from "./WovenClock.vue?vue&type=template&id=65064284&scoped=true"
import script from "./WovenClock.vue?vue&type=script&lang=js"
export * from "./WovenClock.vue?vue&type=script&lang=js"

import "./WovenClock.vue?vue&type=style&index=0&id=65064284&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65064284"]])

export default __exports__